var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _g, _path195, _path196, _g2, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _g3, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _g4, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleActivityBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 389,
    viewBox: "0 0 499 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.945 172.657V124.773H416.298V135.692H396.535V16.0781H358.539V63.1578H347.137V39.6479H317.49V154.301H275.684V113.793H249.471V25.9653H217.12V84.517H186.714V210.655H163.156V149.231H138.83V109.708H112.99V79.3633L84.1584 94.5718V175.757H53.7523V159.011H13.1367V309.792L485.901 310.02V172.657H445.945Z",
    fill: "#212532"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 36.3203H224.52V47.1686H233.986V36.3203Z",
    fill: "#0E0F11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 54.5078H224.52V65.3561H233.986V54.5078Z",
    fill: "#0E0F11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 72.7188H224.52V83.567H233.986V72.7188Z",
    fill: "#0E0F11"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 90.8984H224.52V101.747H233.986V90.8984Z",
    fill: "#0E0F11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 109.086H224.52V119.934H233.986V109.086Z",
    fill: "#0E0F11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 127.281H224.52V138.13H233.986V127.281Z",
    fill: "#0E0F11"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 145.477H224.52V156.325H233.986V145.477Z",
    fill: "#0E0F11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M233.986 163.68H224.52V174.528H233.986V163.68Z",
    fill: "#0E0F11"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 21.8125H366.715V32.6608H376.181V21.8125Z",
    fill: "#0E0F11"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 40H366.715V50.8483H376.181V40Z",
    fill: "#0E0F11"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 58.2109H366.715V69.0592H376.181V58.2109Z",
    fill: "#0E0F11"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 76.3906H366.715V87.2389H376.181V76.3906Z",
    fill: "#0E0F11"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 94.5859H366.715V105.434H376.181V94.5859Z",
    fill: "#0E0F11"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 112.789H366.715V123.637H376.181V112.789Z",
    fill: "#0E0F11"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 130.984H366.715V141.833H376.181V130.984Z",
    fill: "#0E0F11"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M376.181 149.164H366.715V160.012H376.181V149.164Z",
    fill: "#0E0F11"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.162 309.891V135.43H154.5V309.873L192.162 309.891Z",
    fill: "#30384E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 140.969H157.359V150.387H161.924V140.969Z",
    fill: "#0E0F11"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 140.969H166.492V150.387H171.057V140.969Z",
    fill: "#0E0F11"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 140.969H175.617V150.387H180.182V140.969Z",
    fill: "#0E0F11"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 140.969H184.75V150.387H189.315V140.969Z",
    fill: "#0E0F11"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 156.773H157.359V166.192H161.924V156.773Z",
    fill: "#0E0F11"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 156.773H166.492V166.192H171.057V156.773Z",
    fill: "#0E0F11"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 156.773H175.617V166.192H180.182V156.773Z",
    fill: "#0E0F11"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 156.773H184.75V166.192H189.315V156.773Z",
    fill: "#0E0F11"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 172.547H157.359V181.965H161.924V172.547Z",
    fill: "#0E0F11"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 172.547H166.492V181.965H171.057V172.547Z",
    fill: "#0E0F11"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 172.547H175.617V181.965H180.182V172.547Z",
    fill: "#0E0F11"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 172.547H184.75V181.965H189.315V172.547Z",
    fill: "#0E0F11"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 188.344H157.359V197.762H161.924V188.344Z",
    fill: "#0E0F11"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 188.344H166.492V197.762H171.057V188.344Z",
    fill: "#0E0F11"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 188.344H175.617V197.762H180.182V188.344Z",
    fill: "#0E0F11"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 188.344H184.75V197.762H189.315V188.344Z",
    fill: "#0E0F11"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 204.117H157.359V213.535H161.924V204.117Z",
    fill: "#0E0F11"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 204.117H166.492V213.535H171.057V204.117Z",
    fill: "#0E0F11"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 204.117H175.617V213.535H180.182V204.117Z",
    fill: "#0E0F11"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 204.117H184.75V213.535H189.315V204.117Z",
    fill: "#0E0F11"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 219.906H157.359V229.324H161.924V219.906Z",
    fill: "#0E0F11"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 219.906H166.492V229.324H171.057V219.906Z",
    fill: "#0E0F11"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 219.906H175.617V229.324H180.182V219.906Z",
    fill: "#0E0F11"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 219.906H184.75V229.324H189.315V219.906Z",
    fill: "#0E0F11"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 235.688H157.359V245.106H161.924V235.688Z",
    fill: "#0E0F11"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 235.688H166.492V245.106H171.057V235.688Z",
    fill: "#0E0F11"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 235.688H175.617V245.106H180.182V235.688Z",
    fill: "#0E0F11"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 235.688H184.75V245.106H189.315V235.688Z",
    fill: "#0E0F11"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M161.924 251.492H157.359V260.91H161.924V251.492Z",
    fill: "#0E0F11"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M171.057 251.492H166.492V260.91H171.057V251.492Z",
    fill: "#0E0F11"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M180.182 251.492H175.617V260.91H180.182V251.492Z",
    fill: "#0E0F11"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M189.315 251.492H184.75V260.91H189.315V251.492Z",
    fill: "#0E0F11"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M323.035 309.948V115.289H244.949V310.003C244.949 310.003 322.436 310.027 323.035 309.948Z",
    fill: "#171A22"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 121.727H250.816V132.575H260.282V121.727Z",
    fill: "#30384E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 121.727H269.754V132.575H279.22V121.727Z",
    fill: "#30384E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 121.727H288.691V132.575H298.157V121.727Z",
    fill: "#30384E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 121.727H307.633V132.575H317.099V121.727Z",
    fill: "#30384E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 139.93H250.816V150.778H260.282V139.93Z",
    fill: "#30384E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 139.93H269.754V150.778H279.22V139.93Z",
    fill: "#30384E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 139.93H288.691V150.778H298.157V139.93Z",
    fill: "#30384E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 139.93H307.633V150.778H317.099V139.93Z",
    fill: "#30384E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 158.125H250.816V168.973H260.282V158.125Z",
    fill: "#30384E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 158.125H269.754V168.973H279.22V158.125Z",
    fill: "#30384E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 158.125H288.691V168.973H298.157V158.125Z",
    fill: "#30384E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 158.125H307.633V168.973H317.099V158.125Z",
    fill: "#30384E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 176.305H250.816V187.153H260.282V176.305Z",
    fill: "#30384E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 176.305H269.754V187.153H279.22V176.305Z",
    fill: "#30384E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 176.305H288.691V187.153H298.157V176.305Z",
    fill: "#30384E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 176.305H307.633V187.153H317.099V176.305Z",
    fill: "#30384E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 194.508H250.816V205.356H260.282V194.508Z",
    fill: "#30384E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 194.508H269.754V205.356H279.22V194.508Z",
    fill: "#30384E"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 194.508H288.691V205.356H298.157V194.508Z",
    fill: "#30384E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 194.508H307.633V205.356H317.099V194.508Z",
    fill: "#30384E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 212.703H250.816V223.551H260.282V212.703Z",
    fill: "#30384E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 212.703H269.754V223.551H279.22V212.703Z",
    fill: "#30384E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 212.703H288.691V223.551H298.157V212.703Z",
    fill: "#30384E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 212.703H307.633V223.551H317.099V212.703Z",
    fill: "#30384E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 230.898H250.816V241.747H260.282V230.898Z",
    fill: "#30384E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 230.898H269.754V241.747H279.22V230.898Z",
    fill: "#30384E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 230.898H288.691V241.747H298.157V230.898Z",
    fill: "#30384E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 230.898H307.633V241.747H317.099V230.898Z",
    fill: "#30384E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M260.282 249.086H250.816V259.934H260.282V249.086Z",
    fill: "#30384E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M279.22 249.086H269.754V259.934H279.22V249.086Z",
    fill: "#30384E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M298.157 249.086H288.691V259.934H298.157V249.086Z",
    fill: "#30384E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M317.099 249.086H307.633V259.934H317.099V249.086Z",
    fill: "#30384E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M140.807 309.855V101.672H108.504V310.02C118.727 309.768 140.807 309.855 140.807 309.855Z",
    fill: "#171A22"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 105.531H113.281V116.38H122.747V105.531Z",
    fill: "#0E0F11"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 123.719H113.281V134.567H122.747V123.719Z",
    fill: "#0E0F11"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 141.922H113.281V152.77H122.747V141.922Z",
    fill: "#0E0F11"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 160.102H113.281V170.95H122.747V160.102Z",
    fill: "#0E0F11"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 178.297H113.281V189.145H122.747V178.297Z",
    fill: "#0E0F11"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 196.492H113.281V207.34H122.747V196.492Z",
    fill: "#0E0F11"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 214.68H113.281V225.528H122.747V214.68Z",
    fill: "#0E0F11"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M122.747 232.883H113.281V243.731H122.747V232.883Z",
    fill: "#0E0F11"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 105.531H125.941V116.38H135.407V105.531Z",
    fill: "#0E0F11"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 123.719H125.941V134.567H135.407V123.719Z",
    fill: "#0E0F11"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 141.922H125.941V152.77H135.407V141.922Z",
    fill: "#0E0F11"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 160.102H125.941V170.95H135.407V160.102Z",
    fill: "#0E0F11"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 178.297H125.941V189.145H135.407V178.297Z",
    fill: "#0E0F11"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 196.492H125.941V207.34H135.407V196.492Z",
    fill: "#0E0F11"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 214.68H125.941V225.528H135.407V214.68Z",
    fill: "#0E0F11"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M135.407 232.883H125.941V243.731H135.407V232.883Z",
    fill: "#0E0F11"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M450.218 105.391H393.203V310.027H450.218V105.391Z",
    fill: "#171A22"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 113.852H401.633V124.7H418.343V113.852Z",
    fill: "#0E0F11"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 132.055H401.633V142.903H418.343V132.055Z",
    fill: "#0E0F11"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 150.242H401.633V161.09H418.343V150.242Z",
    fill: "#0E0F11"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 168.438H401.633V179.286H418.343V168.438Z",
    fill: "#0E0F11"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 186.633H401.633V197.481H418.343V186.633Z",
    fill: "#0E0F11"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 204.805H401.633V215.653H418.343V204.805Z",
    fill: "#0E0F11"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 223.016H401.633V233.864H418.343V223.016Z",
    fill: "#0E0F11"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M418.343 241.195H401.633V252.044H418.343V241.195Z",
    fill: "#0E0F11"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 113.852H423.992V124.7H440.703V113.852Z",
    fill: "#0E0F11"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 132.055H423.992V142.903H440.703V132.055Z",
    fill: "#0E0F11"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 150.242H423.992V161.09H440.703V150.242Z",
    fill: "#0E0F11"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 168.438H423.992V179.286H440.703V168.438Z",
    fill: "#0E0F11"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 186.633H423.992V197.481H440.703V186.633Z",
    fill: "#0E0F11"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 204.805H423.992V215.653H440.703V204.805Z",
    fill: "#0E0F11"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 223.016H423.992V233.864H440.703V223.016Z",
    fill: "#0E0F11"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M440.703 241.195H423.992V252.044H440.703V241.195Z",
    fill: "#0E0F11"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M355.906 309.973V158.125H331.039V309.961L355.906 309.973Z",
    fill: "#30384E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 162.922H332.93V171.007H335.945V162.922Z",
    fill: "#0E0F11"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 162.922H338.957V171.007H341.972V162.922Z",
    fill: "#0E0F11"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 162.922H344.977V171.007H347.992V162.922Z",
    fill: "#0E0F11"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 162.922H351.004V171.007H354.019V162.922Z",
    fill: "#0E0F11"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 176.5H332.93V184.585H335.945V176.5Z",
    fill: "#0E0F11"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 176.5H338.957V184.585H341.972V176.5Z",
    fill: "#0E0F11"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 176.5H344.977V184.585H347.992V176.5Z",
    fill: "#0E0F11"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 176.5H351.004V184.585H354.019V176.5Z",
    fill: "#0E0F11"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 190.055H332.93V198.139H335.945V190.055Z",
    fill: "#0E0F11"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 190.055H338.957V198.139H341.972V190.055Z",
    fill: "#0E0F11"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 190.055H344.977V198.139H347.992V190.055Z",
    fill: "#0E0F11"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 190.055H351.004V198.139H354.019V190.055Z",
    fill: "#0E0F11"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 203.625H332.93V211.71H335.945V203.625Z",
    fill: "#0E0F11"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 203.625H338.957V211.71H341.972V203.625Z",
    fill: "#0E0F11"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 203.625H344.977V211.71H347.992V203.625Z",
    fill: "#0E0F11"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 203.625H351.004V211.71H354.019V203.625Z",
    fill: "#0E0F11"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 217.195H332.93V225.28H335.945V217.195Z",
    fill: "#0E0F11"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 217.195H338.957V225.28H341.972V217.195Z",
    fill: "#0E0F11"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 217.195H344.977V225.28H347.992V217.195Z",
    fill: "#0E0F11"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 217.195H351.004V225.28H354.019V217.195Z",
    fill: "#0E0F11"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 230.758H332.93V238.843H335.945V230.758Z",
    fill: "#0E0F11"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 230.758H338.957V238.843H341.972V230.758Z",
    fill: "#0E0F11"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 230.758H344.977V238.843H347.992V230.758Z",
    fill: "#0E0F11"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 230.758H351.004V238.843H354.019V230.758Z",
    fill: "#0E0F11"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 244.32H332.93V252.405H335.945V244.32Z",
    fill: "#0E0F11"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 244.32H338.957V252.405H341.972V244.32Z",
    fill: "#0E0F11"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 244.32H344.977V252.405H347.992V244.32Z",
    fill: "#0E0F11"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 244.32H351.004V252.405H354.019V244.32Z",
    fill: "#0E0F11"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M335.945 257.883H332.93V265.968H335.945V257.883Z",
    fill: "#0E0F11"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M341.972 257.883H338.957V265.968H341.972V257.883Z",
    fill: "#0E0F11"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M347.992 257.883H344.977V265.968H347.992V257.883Z",
    fill: "#0E0F11"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M354.019 257.883H351.004V265.968H354.019V257.883Z",
    fill: "#0E0F11"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M111.387 310.031V180.633H44.9062V309.818L111.387 310.031Z",
    fill: "#0E0F11"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 184.648H49.9375V191.436H57.9983V184.648Z",
    fill: "#30384E"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 184.648H66.0625V191.436H74.1234V184.648Z",
    fill: "#30384E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 184.648H82.1758V191.436H90.2366V184.648Z",
    fill: "#30384E"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 184.648H98.293V191.436H106.354V184.648Z",
    fill: "#30384E"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 196.031H49.9375V202.819H57.9983V196.031Z",
    fill: "#30384E"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 196.031H66.0625V202.819H74.1234V196.031Z",
    fill: "#30384E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 196.031H82.1758V202.819H90.2366V196.031Z",
    fill: "#30384E"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 196.031H98.293V202.819H106.354V196.031Z",
    fill: "#30384E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 207.406H49.9375V214.194H57.9983V207.406Z",
    fill: "#30384E"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 207.406H66.0625V214.194H74.1234V207.406Z",
    fill: "#30384E"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 207.406H82.1758V214.194H90.2366V207.406Z",
    fill: "#30384E"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 207.406H98.293V214.194H106.354V207.406Z",
    fill: "#30384E"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 218.789H49.9375V225.576H57.9983V218.789Z",
    fill: "#30384E"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 218.789H66.0625V225.576H74.1234V218.789Z",
    fill: "#30384E"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 218.789H82.1758V225.576H90.2366V218.789Z",
    fill: "#30384E"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 218.789H98.293V225.576H106.354V218.789Z",
    fill: "#30384E"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 230.148H49.9375V236.936H57.9983V230.148Z",
    fill: "#30384E"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 230.148H66.0625V236.936H74.1234V230.148Z",
    fill: "#30384E"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 230.148H82.1758V236.936H90.2366V230.148Z",
    fill: "#30384E"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 230.148H98.293V236.936H106.354V230.148Z",
    fill: "#30384E"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 241.523H49.9375V248.311H57.9983V241.523Z",
    fill: "#30384E"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 241.523H66.0625V248.311H74.1234V241.523Z",
    fill: "#30384E"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 241.523H82.1758V248.311H90.2366V241.523Z",
    fill: "#30384E"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 241.523H98.293V248.311H106.354V241.523Z",
    fill: "#30384E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9983 252.906H49.9375V259.694H57.9983V252.906Z",
    fill: "#30384E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1234 252.906H66.0625V259.694H74.1234V252.906Z",
    fill: "#30384E"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2366 252.906H82.1758V259.694H90.2366V252.906Z",
    fill: "#30384E"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M106.354 252.906H98.293V259.694H106.354V252.906Z",
    fill: "#30384E"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M457.957 367.073C457.957 370.453 364.628 373.193 249.5 373.193C134.373 373.193 41.043 370.453 41.043 367.073C41.043 363.693 134.372 360.953 249.5 360.953C364.629 360.953 457.957 363.693 457.957 367.073Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M227.473 110.301C227.473 110.301 229.822 107.664 230.474 104.547C231.129 101.414 231.563 98.8619 231.501 96.4896C231.438 94.1174 229.409 96.5964 228.596 98.1323C227.784 99.6692 226.848 101.403 225.792 100.605C224.736 99.809 220.269 89.3479 218.679 88.4098C217.091 87.4717 217.283 89.3898 217.283 89.3898C217.283 89.3898 216.129 86.8789 215.011 87.0645C214.719 87.1124 214.122 87.6962 214.468 88.9238C215.246 91.6842 217.179 97.3928 217.179 97.3928C217.075 97.0635 214.185 90.1872 213.618 89.2142C212.877 87.9417 211.879 87.7202 211.155 88.1743C210.125 88.82 213.417 97.4667 213.301 97.9287C213.301 97.9287 211.573 92.8868 210.027 92.6214C208.481 92.3559 209.396 95.5884 210.744 98.286C211.98 100.759 213.757 105.934 215.258 108.325C217.106 111.272 219.011 112.836 222.243 112.401C225.48 111.965 227.473 110.301 227.473 110.301Z",
    fill: "#E9B376"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M217.5 89.6484C218.374 91.6844 219.155 93.7602 219.84 95.867",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M213.906 99.8629C216.148 98.0835 218.921 96.9827 221.773 96.7422",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M225.067 101.789C224.075 102.403 223.308 103.371 222.936 104.477C222.565 105.582 222.591 106.817 223.01 107.905",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M219.84 111.48C219.901 112.259 225.563 119.467 225.065 119.467C224.567 119.467 231.31 116.36 231.506 115.953C231.703 115.545 226.272 109 226.272 109L219.84 111.48Z",
    fill: "#E9B376"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M274.789 121.984L247.479 137.679C247.479 137.679 240.648 124.304 238.663 119.347C236.994 115.181 231.216 113.584 231.216 113.584L228.863 110.953H228.43L220.457 114.777L221.639 117.771C221.639 117.771 221.243 121.324 220.68 124.515C220.116 127.706 235.436 157.404 238.57 160.402C240.83 162.565 247.856 164.382 251.404 162.781C263.834 157.175 282.143 137.679 282.143 137.679L274.789 121.984Z",
    fill: "#263238"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M274.789 121.984L247.479 137.679C247.479 137.679 240.648 124.304 238.663 119.347C236.994 115.181 231.216 113.584 231.216 113.584L228.863 110.953H228.43L220.457 114.777L221.639 117.771C221.639 117.771 221.243 121.324 220.68 124.515C220.116 127.706 235.436 157.404 238.57 160.402C240.83 162.565 247.856 164.382 251.404 162.781C263.834 157.175 282.143 137.679 282.143 137.679L274.789 121.984Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M226.228 347.572C226.438 347.145 228.91 342.597 228.892 342.418L237.966 323.796L217.352 317.359L211.923 341.122C210.644 344.382 207.771 344.955 207.771 344.955C207.771 344.955 199.166 349.142 195.961 348.164C193.857 347.522 191.666 347.617 189.432 349.357C188.795 349.855 188.212 350.483 187.653 351.333C187.033 352.274 186.943 352.675 186.539 354.095L204.556 360.621C204.556 360.621 208.271 361.26 209.313 361.513C210.358 361.767 211.721 363.311 211.721 363.311L220.14 366.47C220.14 366.47 220.815 365.129 221.795 363.177H221.798C222.24 362.297 222.742 361.294 223.275 360.234C225.558 355.689 225.591 348.862 226.228 347.572Z",
    fill: "#263238"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M278.369 193.062C276.433 196.514 211.352 331.615 211.352 331.615L233.815 337.636L253.503 299.086L298.944 214.12L278.369 193.062Z",
    fill: "#945C64"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M278.369 193.062C276.433 196.514 211.352 331.615 211.352 331.615L233.815 337.636L253.503 299.086L298.944 214.12L278.369 193.062Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M137.901 192.008C137.382 192.354 130.982 195.813 132.02 206.71C133.058 217.608 137.901 219.856 137.901 219.856V192.008Z",
    fill: "#407BFF"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M165.864 214.827C165.864 214.827 154.508 221.417 137.902 219.86V192.012C137.902 192.012 152.605 188.206 163.675 195.471C173.027 201.609 165.864 214.827 165.864 214.827Z",
    fill: "#263238"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M165.864 214.827C165.864 214.827 154.508 221.417 137.902 219.86V192.012C137.902 192.012 152.605 188.206 163.675 195.471C173.027 201.609 165.864 214.827 165.864 214.827Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M132.91 182.239C132.91 182.239 153.989 174.073 168.952 185.133C179.532 192.952 181.054 203.811 181.054 203.811L175.003 209.336L132.91 182.239Z",
    fill: "#263238"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M442.7 256.656C442.7 256.656 443.965 270.1 443.045 270.1C442.126 270.1 440.057 270.1 440.057 270.1L433.277 256.656",
    fill: "#B97964"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M116.88 311.163L111.551 308.263L171.247 198.576L202.954 165.641L207.325 169.848L176.185 202.194L116.88 311.163Z",
    fill: "#263238"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M116.88 311.163L111.551 308.263L171.247 198.576L202.954 165.641L207.325 169.848L176.185 202.194L116.88 311.163Z",
    fill: "white"
  }))), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M205.643 175.927C210.559 175.927 214.545 171.942 214.545 167.026C214.545 162.11 210.559 158.125 205.643 158.125C200.727 158.125 196.742 162.11 196.742 167.026C196.742 171.942 200.727 175.927 205.643 175.927Z",
    fill: "#263238"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M237.796 326.133C234.034 326.133 230.524 326.07 227.486 325.944C211.507 325.279 205.773 319.684 201.167 315.19C200.393 314.434 199.661 313.721 198.932 313.088C193.707 308.558 166.082 246.796 157.738 227.975L163.286 225.516C176.624 255.61 199.187 304.762 202.943 308.537C203.771 309.254 204.601 310.064 205.405 310.848C209.472 314.816 214.081 319.314 227.739 319.883C246.376 320.658 275.716 318.968 280.941 316.818C286.579 314.496 297.23 300.423 302.348 293.659C313.667 278.704 327.297 257.154 327.433 256.938L332.562 260.177C332.425 260.395 318.661 282.158 307.186 297.32C298.702 308.53 289.865 319.704 283.252 322.427C277.417 324.83 255.006 326.133 237.796 326.133Z",
    fill: "#263238"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.796 326.133C234.034 326.133 230.524 326.07 227.486 325.944C211.507 325.279 205.773 319.684 201.167 315.19C200.393 314.434 199.661 313.721 198.932 313.088C193.707 308.558 166.082 246.796 157.738 227.975L163.286 225.516C176.624 255.61 199.187 304.762 202.943 308.537C203.771 309.254 204.601 310.064 205.405 310.848C209.472 314.816 214.081 319.314 227.739 319.883C246.376 320.658 275.716 318.968 280.941 316.818C286.579 314.496 297.23 300.423 302.348 293.659C313.667 278.704 327.297 257.154 327.433 256.938L332.562 260.177C332.425 260.395 318.661 282.158 307.186 297.32C298.702 308.53 289.865 319.704 283.252 322.427C277.417 324.83 255.006 326.133 237.796 326.133Z",
    fill: "white"
  }))), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M328.566 239.493L322.66 243.227L366.542 312.651L372.448 308.917L328.566 239.493Z",
    fill: "#263238"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M344.633 252.846C344.633 252.846 359.991 244.687 391.416 251.303C422.841 257.918 430.875 282.964 430.875 282.964H441.745C441.745 282.964 435.129 255.32 399.923 242.324C370.35 231.408 360.228 239.015 351.485 241.379C342.743 243.742 344.633 252.846 344.633 252.846Z",
    fill: "#407BFF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M239.676 324.682L256.405 331.716C258.391 332.551 260.525 332.981 262.68 332.981H374.262V318.625L286.332 319.522L239.676 324.682Z",
    fill: "#263238"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M314.447 246.235C313.077 246.388 265.725 246.235 265.725 246.235C265.725 246.235 265.572 273.282 267.564 274.927C269.556 276.572 271.24 276.088 271.24 276.088C271.24 276.088 273.079 287.775 285.489 288.378C297.899 288.982 301.116 285.767 305.253 284.846C309.39 283.926 327.281 257.585 326.379 255.203C325.479 252.823 321.342 245.469 314.447 246.235Z",
    fill: "#263238"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M314.447 246.235C313.077 246.388 265.725 246.235 265.725 246.235C265.725 246.235 265.572 273.282 267.564 274.927C269.556 276.572 271.24 276.088 271.24 276.088C271.24 276.088 273.079 287.775 285.489 288.378C297.899 288.982 301.116 285.767 305.253 284.846C309.39 283.926 327.281 257.585 326.379 255.203C325.479 252.823 321.342 245.469 314.447 246.235Z",
    fill: "#407BFF"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M174.702 198.281C175.48 197.762 196.739 203.85 196.739 203.85L191.048 241.375L200.907 255.204L223.322 248.271L231.264 260.554L228.41 263.432L232.574 271.982L241.123 263.432V258.997C241.123 258.997 253.318 258.997 254.096 258.997C254.875 258.997 267.329 258.997 267.329 258.997L316.108 259.256L324.93 266.407L290.68 309.923L270.33 312.764L208.702 294.025C208.702 294.025 195.456 261.851 183.78 246.18C172.105 230.51 168.472 238.499 168.481 238.737L161.68 222.506L174.958 199.58",
    fill: "#263238"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M174.702 198.281C175.48 197.762 196.739 203.85 196.739 203.85L191.048 241.375L200.907 255.204L223.322 248.271L231.264 260.554L228.41 263.432L232.574 271.982L241.123 263.432V258.997C241.123 258.997 253.318 258.997 254.096 258.997C254.875 258.997 267.329 258.997 267.329 258.997L316.108 259.256L324.93 266.407L290.68 309.923L270.33 312.764L208.702 294.025C208.702 294.025 195.456 261.851 183.78 246.18C172.105 230.51 168.472 238.499 168.481 238.737L161.68 222.506L174.958 199.58",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M422.363 255.375H433.968L441.208 271.463H435.118L422.363 255.375Z",
    fill: "#407BFF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M344.463 239.883C345.191 242.131 356.925 254.742 356.925 254.742L344.463 260.921L333.234 246.18L344.463 239.883Z",
    fill: "#263238"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M328.566 239.493L322.66 243.227L366.542 312.651L372.448 308.917L328.566 239.493Z",
    fill: "white"
  }))), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M344.463 239.883C345.191 242.131 356.925 254.742 356.925 254.742L344.463 260.921L333.234 246.18L344.463 239.883Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M135.085 314.615C137.781 303.086 130.621 291.554 119.092 288.858C107.563 286.162 96.0309 293.322 93.3348 304.851C90.6387 316.38 97.7993 327.912 109.328 330.608C120.857 333.304 132.389 326.144 135.085 314.615Z",
    fill: "#263238"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M376.915 251.289C344.054 251.289 317.414 277.929 317.414 310.79C317.414 343.651 344.054 370.291 376.915 370.291C409.776 370.291 436.416 343.651 436.416 310.79C436.416 277.928 409.776 251.289 376.915 251.289ZM376.915 355.999C351.35 355.999 330.626 335.275 330.626 309.71C330.626 284.145 351.35 263.421 376.915 263.421C402.48 263.421 423.204 284.145 423.204 309.71C423.204 335.275 402.48 355.999 376.915 355.999Z",
    fill: "#263238"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M397.784 314.638C400.48 303.109 393.32 291.577 381.791 288.881C370.262 286.185 358.73 293.346 356.034 304.875C353.338 316.404 360.499 327.936 372.028 330.632C383.557 333.328 395.088 326.167 397.784 314.638Z",
    fill: "#263238"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M239.676 324.682L256.405 331.716C258.391 332.551 260.525 332.981 262.68 332.981H374.262V318.625L286.332 319.522L239.676 324.682Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M291.375 224.623C291.375 224.623 268.489 222.36 273.519 232.168C278.549 241.976 288.86 248.264 306.464 248.264C324.068 248.264 354.499 245.541 368.08 238.729C381.661 231.916 380.152 223.366 379.649 215.319C379.146 207.271 372.858 204.587 363.804 209.324C354.75 214.061 353.343 213.975 340.164 217.582C326.379 221.354 305.998 224.133 291.375 224.623Z",
    fill: "#263238"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M241.258 319.773C246.108 319.466 252.616 319.622 257.375 318.639C262.135 317.657 267.097 316.405 270.33 312.777C273.637 309.066 274.76 305.166 275.512 300.254C276.012 296.986 274.662 292.172 272.809 289.434C271.387 287.332 268.995 286.043 266.53 285.44C264.065 284.838 261.496 284.849 258.958 284.863C246.307 284.936 233.501 285.028 221.258 288.213C216.206 289.527 211.116 291.47 207.456 295.192C203.797 298.913 201.916 304.781 204.095 309.524C206.038 313.755 210.563 316.115 214.909 317.783C214.909 317.783 223.667 320.884 241.258 319.773Z",
    fill: "#263238"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.258 319.773C246.108 319.466 252.616 319.622 257.375 318.639C262.135 317.657 267.097 316.405 270.33 312.777C273.637 309.066 274.76 305.166 275.512 300.254C276.012 296.986 274.662 292.172 272.809 289.434C271.387 287.332 268.995 286.043 266.53 285.44C264.065 284.838 261.496 284.849 258.958 284.863C246.307 284.936 233.501 285.028 221.258 288.213C216.206 289.527 211.116 291.47 207.456 295.192C203.797 298.913 201.916 304.781 204.095 309.524C206.038 313.755 210.563 316.115 214.909 317.783C214.909 317.783 223.667 320.884 241.258 319.773Z",
    fill: "white"
  }))), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M233.09 304.971C234.47 299.153 230.873 293.319 225.055 291.939C219.237 290.559 213.402 294.156 212.022 299.974C210.642 305.792 214.24 311.627 220.057 313.007C225.875 314.387 231.71 310.789 233.09 304.971Z",
    fill: "#263238"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M264.048 308.489C268.793 303.744 268.793 296.052 264.048 291.308C259.304 286.564 251.612 286.564 246.868 291.308C242.123 296.052 242.123 303.744 246.868 308.489C251.612 313.233 259.304 313.233 264.048 308.489Z",
    fill: "#263238"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M223.398 205.653C222.639 205.535 173.039 194.818 177.183 226.94C177.183 226.94 180.706 243.726 189.825 245.798C197.53 247.549 253.762 246.341 271.016 245.925C274.566 245.839 277.855 243.992 279.708 240.964C279.728 240.932 279.747 240.9 279.767 240.868C281.721 237.65 281.96 226.433 273.343 219.066C260.493 208.081 234.536 207.396 223.398 205.653Z",
    fill: "#407BFF"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7882 259.074L80.3281 253.232C80.3281 253.232 116.317 233.427 148.474 253.232C148.474 253.232 197.049 281.555 173.72 338.626L168.224 335.805C168.224 335.805 170.834 318.821 165.297 295.822C159.76 272.823 143.789 258.555 124.836 255.786C105.882 253.019 84.7882 259.074 84.7882 259.074Z",
    fill: "#407BFF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M114.22 251.289C81.3584 251.289 54.7188 277.929 54.7188 310.79C54.7188 343.651 81.3584 370.291 114.22 370.291C147.081 370.291 173.72 343.651 173.72 310.79C173.72 277.928 147.081 251.289 114.22 251.289ZM114.22 355.999C88.6547 355.999 67.9303 335.275 67.9303 309.71C67.9303 284.145 88.6547 263.421 114.22 263.421C139.784 263.421 160.509 284.145 160.509 309.71C160.509 335.275 139.784 355.999 114.22 355.999Z",
    fill: "#263238"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M278.902 107.029C278.902 107.029 275.972 101.145 275.998 89.2337C275.994 89.2217 275.341 89.1319 275.337 89.1199C275.334 87.4563 275.393 85.9004 275.48 84.5421C275.48 84.5032 275.476 84.4922 275.476 84.4922L263.109 98.1119C264.474 101.526 265.166 108.683 265.238 111.769C265.238 111.769 264.834 117.511 271.811 115.751C276.909 114.463 278.902 107.029 278.902 107.029Z",
    fill: "#E9B376"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.273 103.128L272.368 98.6875C272.357 101.605 270.892 105.481 264.944 107.473C264.944 107.473 264.678 104.288 264.273 103.128Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M245.239 75.1115C244.47 79.0995 246.043 86.9318 251.126 83.7432C255.077 81.2652 250.672 70.9938 247.651 70.7822C246.784 70.7223 245.534 73.5856 245.239 75.1115Z",
    fill: "#263238"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M273.489 77.1486C275.555 86.9101 276.391 92.4819 272.672 98.5827C267.078 107.759 254.348 106.238 249.706 97.0996C245.529 88.8741 243.404 74.1866 251.999 68.1457C260.466 62.1946 271.91 69.6876 273.489 77.1486Z",
    fill: "#E9B376"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M274.077 63.5187C267.694 59.9209 255.927 63.3441 252.845 66.9668C252.385 67.5077 261.261 69.5876 260.739 69.5277L264.778 69.9229C265.321 69.6574 266.611 70.0586 267.624 71.7033C267.624 71.7033 268.661 82.2971 273.898 85.5855C277.639 82.6364 278.38 80.6424 278.606 76.8829C278.942 71.2802 276.968 65.9518 274.077 63.5187Z",
    fill: "#263238"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M279.249 84.3053C279.074 86.9839 277.669 89.3222 275.977 90.7374C273.431 92.8661 270.767 90.915 270.309 87.7983C269.897 84.9929 270.725 80.5059 273.84 79.5837C276.909 78.6755 279.45 81.2424 279.249 84.3053Z",
    fill: "#E9B376"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M262.357 82.6849C262.594 83.6759 262.26 84.6001 261.61 84.7488C260.959 84.8985 260.24 84.2159 260.002 83.2248C259.765 82.2338 260.099 81.3097 260.749 81.161C261.398 81.0123 262.119 81.6939 262.357 82.6849Z",
    fill: "#263238"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M251.649 85.5436C251.887 86.5346 251.553 87.4587 250.903 87.6084C250.253 87.7581 249.533 87.0755 249.295 86.0845C249.058 85.0935 249.392 84.1693 250.042 84.0206C250.691 83.8709 251.412 84.5526 251.649 85.5436Z",
    fill: "#263238"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M253.66 84.4922C253.66 84.4922 251.704 90.1688 251.18 92.4143C252.858 93.3295 255.096 92.1848 255.096 92.1848L253.66 84.4922Z",
    fill: "#D58745"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M261.602 78.017C261.467 78.1139 261.284 78.1378 261.121 78.063C259.177 77.1787 257.676 78.0929 257.661 78.1019C257.437 78.2416 257.141 78.1747 257 77.9532C256.858 77.7316 256.926 77.4382 257.148 77.2985C257.227 77.2486 259.106 76.1029 261.518 77.2007C261.758 77.3105 261.865 77.5919 261.755 77.8304C261.72 77.9083 261.667 77.9711 261.602 78.017Z",
    fill: "#263238"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M276.4 82.1562C275.871 81.6712 275.025 81.6502 274.387 81.9786C273.75 82.3079 273.303 82.9267 273.025 83.5873C272.69 84.3808 272.568 85.262 272.673 86.1173",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M264.488 89.6016L257.031 94.9019C257.793 95.6624 258.566 96.4319 259.498 96.9698C260.43 97.5077 261.423 97.5556 262.462 97.2772C263.95 96.879 265.085 95.6205 265.296 94.0956C265.507 92.5706 265.066 91.0297 264.488 89.6016Z",
    fill: "black"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M257.625 94.4758C257.625 94.4758 258.501 95.3461 259.067 95.3451C259.632 95.3441 265.025 91.1165 265.025 91.1165L264.482 89.6016L257.625 94.4758Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M261.359 97.4512C261.359 97.4512 261.337 95.8664 262.842 94.6708C264.347 93.4752 265.339 93.564 265.339 93.564C265.339 93.564 265.35 95.4472 263.92 96.532C262.49 97.6159 261.359 97.4512 261.359 97.4512Z",
    fill: "#DE5753"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M245.343 82.64C245.252 82.642 245.16 82.618 245.077 82.5661C244.854 82.4254 244.784 82.13 244.924 81.9075C246.315 79.6749 248.507 79.639 248.605 79.625C248.868 79.622 249.087 79.8326 249.092 80.0961C249.098 80.3586 248.892 80.5741 248.63 80.5791C248.538 80.5771 246.851 80.627 245.733 82.4184C245.646 82.5592 245.497 82.637 245.343 82.64Z",
    fill: "#263238"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M274.239 317.658C274.14 317.173 273.277 311.874 273.149 311.739L268.757 290.703L247.762 298.523L258.41 321.459C259.433 324.946 257.441 327.242 257.441 327.242C257.441 327.242 253.045 336.143 249.795 337.378C247.662 338.188 245.926 339.659 245.2 342.505C244.994 343.32 244.915 344.204 244.997 345.257C245.087 346.422 245.267 346.808 245.838 348.229L264.76 342.131C264.76 342.131 268.213 340.295 269.228 339.84C270.247 339.385 272.345 339.784 272.345 339.784L281.256 337.024C281.256 337.024 280.958 335.495 280.52 333.272L280.522 333.27C280.325 332.268 280.1 331.126 279.864 329.919C278.849 324.739 274.537 319.12 274.239 317.658Z",
    fill: "#263238"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M315.693 178.508L276.413 193.508L280.699 203.064C280.699 203.064 235.096 224.9 230.305 238.277C230.198 256.668 250.768 305.115 254.75 319.32L281.254 312.7C278.805 299.093 263.704 252.221 263.704 252.221C267.077 247.335 266.125 246.161 288.428 237.587C303.769 231.689 323.213 222.784 325.347 220.178C332.321 212.01 325.436 191.035 315.693 178.508Z",
    fill: "#945C64"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M315.693 178.508L276.413 193.508L280.699 203.064C280.699 203.064 235.096 224.9 230.305 238.277C230.198 256.668 250.768 305.115 254.75 319.32L281.254 312.7C278.805 299.093 263.704 252.221 263.704 252.221C267.077 247.335 266.125 246.161 288.428 237.587C303.769 231.689 323.213 222.784 325.347 220.178C332.321 212.01 325.436 191.035 315.693 178.508Z",
    fill: "black"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M281.1 103.463C281.1 103.463 291.777 108.413 297.975 115.387C304.175 122.361 323.805 166.271 322.772 172.471C321.739 178.671 320.41 183.602 320.41 183.602L323.157 188.315L279.249 201.826L276.981 198.246C276.981 198.246 276.279 199.402 271.63 192.007C266.981 184.612 259.837 139.774 262.667 130.762C262.91 129.99 264.22 124.6 264.291 121.862C264.43 116.501 263.127 112.478 263.127 112.478L280.183 93.5312L281.1 103.463Z",
    fill: "#263238"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M266.934 173.791L268.113 180.131C268.113 180.131 283.286 150.81 277.909 139.773L266.934 173.791Z",
    fill: "black"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M227.387 174.953L216.08 172.391C216.08 172.391 213.646 173.69 211.716 174.193C209.786 174.696 209.101 175.289 206.161 173.761C203.221 172.232 204.779 169.74 204.779 169.74C202.878 170.043 202.756 166.978 202.756 166.978C200.323 165.348 202.054 162.814 202.054 162.814C202.054 162.814 203.583 159.671 204.906 158.76C206.227 157.848 211.91 158.876 211.91 158.876L216.513 162.411L229.641 163.02C229.609 163.248 227.387 174.953 227.387 174.953Z",
    fill: "#E9B376"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M266.609 121.873C266.609 121.873 261.968 131.051 260.331 137.866C258.828 144.124 252.806 160.993 252.806 160.993L216.915 161.725L214.512 173.453C214.512 173.453 256.811 183.574 262.935 178.896C269.058 174.219 271.512 165.141 275.756 155.759C279.778 146.868 281.641 140.061 282.067 138.636C282.915 135.801 286.091 122.861 279.104 118.321C272.117 113.78 266.609 121.873 266.609 121.873Z",
    fill: "#263238"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M281.536 336.528L241.656 348.445L243.038 353.068L282.917 341.152L281.536 336.528Z",
    fill: "#263238"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M281.536 336.528L241.656 348.445L243.038 353.068L282.917 341.152L281.536 336.528Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M265.72 249.253L256.121 245.242C256.121 245.242 268.873 246.899 268.342 246.72C267.81 246.541 265.72 249.253 265.72 249.253Z",
    fill: "black"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M267.401 68.7052C264.158 65.0435 259.596 59.4348 254.752 58.7571C249.907 58.0795 246.149 59.2172 242.644 62.6294C239.861 65.339 238.553 66.4976 237.943 67.6364C237.334 68.7751 237.267 70.282 238.069 71.294C238.872 72.306 240.639 72.4886 241.43 71.4667C240.267 71.2072 239.1 72.3329 239.076 73.5255C239.051 74.7182 239.933 75.794 241.018 76.289C242.103 76.784 243.349 76.79 244.531 76.6353C252.192 75.6343 260.257 68.1383 267.954 68.802",
    fill: "#263238"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M265.038 125.175C265.038 125.175 267.463 115.214 278.127 117.761C278.127 117.761 272.664 114.837 268.334 117.344C264.003 119.852 265.038 125.175 265.038 125.175Z",
    fill: "black"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M212.677 167.019C212.677 169.458 210.7 171.435 208.26 171.435C205.821 171.435 203.844 169.458 203.844 167.019C203.844 164.58 205.821 162.602 208.26 162.602C210.699 162.603 212.677 164.58 212.677 167.019Z",
    fill: "#263238"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M248.517 79.6294C246.056 80.3739 244.616 81.338 243.912 81.9168C243.561 82.2062 243.355 82.6084 243.326 83.0426C243.201 84.9198 243.13 90.2721 247.71 89.6892C253.104 89.0026 252.987 84.834 253.055 82.331C253.123 79.829 252.287 78.4897 248.517 79.6294Z",
    fill: "#263238"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M257.7 77.3559C260.23 76.811 263.352 76.5445 264.274 76.7312C264.735 76.824 265.131 77.0954 265.392 77.4866C266.521 79.1733 268.135 84.5674 263.861 86.3299C258.827 88.4058 257.269 85.4377 255.851 83.1383C254.433 80.8369 253.822 78.1902 257.7 77.3559Z",
    fill: "#263238"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M264.719 77.625L273.856 79.5711",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M252.074 80.6054C252.506 80.1074 253.114 79.766 253.765 79.6563C254.416 79.5465 255.101 79.6702 255.673 79.9996",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M241.021 183.045C221.115 178.533 214.202 200.297 214.202 200.297H207.844C206.569 200.297 206.253 201.025 206.332 201.901C206.484 203.599 207.911 204.908 209.605 205.113L256.876 210.847C256.876 210.847 260.927 187.557 241.021 183.045Z",
    fill: "#263238"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M257.115 203.363C257.115 203.363 257.183 192.48 249.572 187.039C249.572 187.039 243.281 189.429 243.994 194.921C244.705 200.413 251.825 200.617 251.825 200.617C251.825 200.617 252.74 204.888 254.063 203.566C254.896 202.733 254.977 201.9 254.923 201.398C255.14 202.25 255.714 204.057 256.605 203.819C257.096 203.69 257.115 203.363 257.115 203.363Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M248.167 192.909C248.115 193.141 247.643 197.004 251.119 197.385C254.595 197.766 254.308 194.957 253.071 193.814C251.833 192.671 248.643 190.767 248.167 192.909Z",
    fill: "#263238"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M214.207 200.295C214.207 200.295 230.279 201.314 235.906 202.202C241.532 203.09 214.773 198.797 214.773 198.797L214.207 200.295Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M320.41 183.609C319.689 183.716 276.98 198.254 276.98 198.254",
    stroke: "black",
    strokeWidth: 0.499,
    strokeMiterlimit: 10
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M206.325 205.548C206.325 205.548 187.736 214.111 187.123 222.311C186.391 232.133 188.589 242.102 188.589 242.102C188.589 242.102 175.15 227.86 181.054 217.535C186.959 207.21 203.681 205.059 206.325 205.548Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.685 216.709L160.841 199.328L144.398 218.865L151.685 216.709Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M338.491 347.834C337.806 346.683 336.28 345.269 335.211 344.464C334.143 343.658 332.677 343.256 331.437 343.764C329.855 344.412 329.127 346.351 329.347 348.046C329.568 349.74 330.376 351.882 331.34 353.293C335.453 359.315 339.26 364.826 345.608 369.307C345.608 361.828 342.287 354.213 338.491 347.834Z",
    fill: "#407BFF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M359.428 348.872C358.008 348.095 355.366 349.197 354.071 350.168C351.501 352.093 349.936 354.109 348.371 356.912C346.382 360.471 346.151 365.469 345.898 368.643C350.925 364.562 356.045 360.378 359.487 354.894C360.088 353.937 360.646 352.909 360.754 351.784C360.861 350.66 360.418 349.415 359.428 348.872Z",
    fill: "#407BFF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M340.047 356.609C343.018 361.399 345.162 366.7 346.353 372.209",
    stroke: "#263238",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M351.494 359.039C348.996 362.034 347.024 365.466 345.695 369.132",
    stroke: "#263238",
    strokeWidth: 0.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleActivityBlank);
export default __webpack_public_path__ + "static/media/vehicle-activity-blank.b4220fb0662e08cdf113bc2a68fb467b.svg";
export { ForwardRef as ReactComponent };